/** Whether an item is found for a search: its `value`, its `keywords`, and the search text, which is not blank. */
export type CommandFilter = (value: string, search: string, keywords: readonly string[]) => boolean;

/** Case- and accent-insensitive: "zurich" finds "Zürich". */
const normalize = (text: string): string =>
    text
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLocaleLowerCase();

/** The default filter: an item is found when its value or keywords contain every word of the search, ignoring case and accents. */
export const defaultCommandFilter: CommandFilter = (value, search, keywords) => {
    const words = normalize(search).split(/\s+/).filter(Boolean);
    const text = normalize([value, ...keywords].join(' '));
    return words.every((word) => text.includes(word));
};
